export { default as MailFolderTreesParentContainer, } from './components/MailFolderTreesParentContainer';
import { createLazyComponent, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(
    /* webpackChunkName: "MailFolderTreeContainerView", webpackPrefetch: true */ './lazyIndex');
});
// Delay loaded components
export var ArchiveMailFolderTreeContainer = createLazyComponent(lazyModule, function (m) { return m.ArchiveMailFolderTreeContainer; });
export var SharedFolderTreeParentContainer = createLazyComponent(lazyModule, function (m) { return m.SharedFolderTreeParentContainer; });
//# sourceMappingURL=index.js.map